import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Snapchat32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M16.126 25c-.051 0-.102-.001-.153-.004a1.242 1.242 0 01-.1.004c-1.184 0-1.945-.544-2.68-1.07-.508-.363-.987-.706-1.552-.801a4.962 4.962 0 00-.814-.07c-.478 0-.854.075-1.13.129a2.446 2.446 0 01-.42.062c-.115 0-.239-.026-.293-.212a6.8 6.8 0 01-.113-.47c-.084-.389-.143-.628-.305-.653-1.879-.294-2.417-.694-2.537-.979A.37.37 0 016 20.815a.214.214 0 01.177-.224c2.89-.481 4.185-3.47 4.238-3.596l.005-.01c.177-.363.211-.678.103-.936-.198-.473-.845-.68-1.273-.818-.104-.034-.204-.065-.282-.097-.854-.341-.925-.692-.891-.871.057-.305.459-.517.784-.517.09 0 .168.016.234.047.384.183.73.275 1.03.275.412 0 .592-.176.614-.199-.01-.198-.023-.404-.037-.618-.086-1.382-.192-3.1.24-4.08 1.295-2.939 4.041-3.167 4.852-3.167L16.149 6h.048c.813 0 3.565.229 4.861 3.17.432.98.325 2.7.24 4.08l-.004.06c-.012.193-.024.38-.033.559.02.021.186.183.56.197.285-.01.612-.103.97-.273a.724.724 0 01.302-.06c.121 0 .244.024.347.067l.006.003c.29.104.48.31.484.525.004.202-.149.507-.898.806-.078.031-.177.063-.282.097-.429.137-1.075.345-1.273.818-.109.258-.074.572.103.935l.005.01c.053.128 1.348 3.115 4.238 3.597a.214.214 0 01.177.223.362.362 0 01-.03.123c-.12.282-.657.682-2.536.976-.154.024-.213.227-.305.651a6.627 6.627 0 01-.114.466c-.04.139-.125.204-.268.204h-.024c-.1 0-.241-.018-.42-.054a5.548 5.548 0 00-1.13-.121c-.265 0-.539.023-.815.07-.564.095-1.043.437-1.55.8-.736.527-1.497 1.071-2.682 1.071"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Snapchat32;
